<template lang="pug">
  div.wrap-shared-footer.py20
    div.footer-content.f.fc.mt12
      div
        a(href="/privacy_policy.pdf" target="brank").fz12.mr8 Privacy Policy
        a(href="/service_terms.pdf" target="brank").fz12.mr8 Service Terms
        a(href="mailto:hello@hackin.wiki").fz12 Contact
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-shared-footer {
  background: $primary_bg_color;
  border-bottom: solid $border_size $border_color;
  .header-content {
    position: relative;
    width: $base_width_percent;
    max-width: $base_max_width_px;
    height: 100%;
  }
}
</style>

<script>

export default {
  
}
</script>
